import axios from 'axios';
import  store from '../redux/store'
import urls from "../configmap/config.json";
const baseURL = urls.restrictedApiUrl;

const restrictedAxiosInstance = axios.create({
  baseURL,  // Set the base URL dynamically using the domainNameResolver
  headers: {
    'Content-Type': 'application/json', // Default content type for JSON API calls
  },
});

// Axios request interceptor to add the access token to the headers
restrictedAxiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = store.getState().auth.accessToken;
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);




export default restrictedAxiosInstance;
